import { z } from 'zod';

import { BaseLoanEvent } from './BaseLoanEvent';

export const SendWelcomeEmailEvent = BaseLoanEvent.extend({
  type: z.literal('sendWelcomeEmail'),
  ignoreDateCheck: z.boolean().optional(),
});
export type SendWelcomeEmailEvent = z.infer<typeof SendWelcomeEmailEvent>;
